import AddNewCreateUserLinkButtonPresenter from "../AddNewCreateUserLinkButton/AddNewCreateUserLinkButtonPresenter"
import NewCreateUserLinkModal from "../NewCreateUserLinkModal/NewCreateUserLinkModal"

export default function AddNewCreateUserLinkFormModal({modalId}: {modalId?: string}) {

 
   return (
     <>
     <AddNewCreateUserLinkButtonPresenter modalId={modalId} />
     <NewCreateUserLinkModal modalId={modalId} />
     </>
   )
 }